import { combineReducers } from 'redux';

import { reducer } from '../query/store';

const rootReducer = combineReducers({
    query: reducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/components/manHour/store/index.js